// extracted by mini-css-extract-plugin
export default {"wrapper":"login_wrapper__YZ3FB","back":"login_back__Njiwq","header":"login_header__V-ns4","form":"login_form__OBGEf","forgotPassword":"login_forgotPassword__Gex6l"};